// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3VhkA","title":"ClientInsurance_title__1Fi1-","itemText":"ClientInsurance_itemText__3c3Ml"};